import React from 'react';
import { OrganizationOfficeDto } from 'src/api/FiretrolApiClient';
import { useOrganization } from 'src/hooks/useOrganization';
import { PersistentSelect } from 'src/design/atoms/PersistentSelect';

export interface IOfficeSelectorV2Props {
  onChange: (offices: OrganizationOfficeDto[]) => void;
  initialValue: OrganizationOfficeDto[];
}

export const OfficeSelectorV2: React.FC<IOfficeSelectorV2Props> = ({
  onChange,
  initialValue,
}) => {
  const { offices } = useOrganization();
  const [selected, setSelected] =
    React.useState<OrganizationOfficeDto[]>(initialValue);

  React.useEffect(() => {
    if (selected) {
      onChange(selected);
    } else {
      onChange([]);
    }
  }, [selected]);

  React.useEffect(() => {
    setSelected(initialValue);
  }, [initialValue]);

  const onValueChange = (value: OrganizationOfficeDto[]) => {
    setSelected(value);
  };

  return (
    <div style={{ width: '100%' }}>
      <PersistentSelect
        options={offices}
        value={selected}
        onChange={onValueChange}
        placeholder="Select Office"
        inputProps={{
          label: undefined,
        }}
        emptyMessage="No available offices..."
        getOptionId={(option) => option.id.toString()}
        getOptionLabel={(option) => option.name}
      />
    </div>
  );
};
